/*
 * fn: getCardName
 *
 * Creates a full card name (combines front and back names)
 *
 */
import { isNonEmptyString } from '@/utils/commonUtil'

export const getCardName = (front?: string, back?: string) => [front, back].filter(isNonEmptyString).join(' // ')
